<template>
    <v-app>

        <v-main>
            <slot />
        </v-main>

    </v-app>
</template>

<script lang="ts" src="./DefaultLayout.ts" />